import React from "react";
import SelectedAmount from "../../../components/comment/selectedAmount/selectedAmt";

const amount = () => {
  return (
    <div className="netbank-amt-wrap">
      <div className="row">
        <div className="col-lg-12">
          <div className="rightbar-title">Net banking</div>
        </div>
      </div>

      <SelectedAmount />
    </div>
  );
};

export default amount;
